module.exports = __webpack_public_path__ + "static/media/WctCardImg1.c65f782f.png";